/* eslint-disable react/prop-types */
import { m } from 'framer-motion';
// @mui
import { Box, Card, Container, Divider, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useSelector } from '../../redux/store';
// hooks
import Link from 'next/link';
import licenseDetails from '../../assets/licenseDetails.json';
import reviewTopicMap from '../../assets/reviewTopicMap.json';
import CardAds from '../../components/CardAds';
import Image from '../../components/Image';
import { MotionViewport, varFade } from "../../components/animate";
import useSettings from '../../hooks/useSettings';
import Layout from '../../layouts';
import { topic } from '../../utils/mapLicense';
import { Exam200Header } from '../exam/Exam200Header';
import LicenseTypeItem from '../practicalExam/LicenseTypeItem';
import MotorSlider from './MotorSlider';

HomeBike.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};
const data = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'C', 'D', 'E', 'F'];
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
  },
}));

const Item = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.neutral,
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.primary,
  paddingBottom: 30,
  '&:hover': {
    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
  },
  cursor: 'pointer'
}));

const Header = styled(Box)(({ theme }) => ({
  width: 70,
  borderRadius: 25,
  padding: 5,
  ...theme.typography.body1,
  color: "#fff"
}));

// ----------------------------------------------------------------------

export default function HomeBike({ licenseTypes }) {
  const { themeStretch } = useSettings();
  const { totalExams, licenseName, licenseIndex, licenseResultOfUser, licenseWrongQuestions } = useSelector((state) => state.exam);
  const [surprise, setSupprise] = useState(checkLicenseIndexSupprise(licenseIndex));
  const [array, setArray] = useState(checkLicenseIndexArray(licenseIndex));
  const wrongQuestions = licenseWrongQuestions?.[licenseIndex].reduce((partialSum, e) => partialSum + e.length, 0);

  useEffect(() => {
    if (licenseIndex > 4) {
      setSupprise(topic(reviewTopicMap[4][1].indexes));
      setArray(reviewTopicMap[4][0].indexes);
    } else {
      setSupprise(topic(reviewTopicMap[licenseIndex][1].indexes));
      setArray(reviewTopicMap[licenseIndex][0].indexes);
    }
  }, [licenseIndex]);

  function checkLicenseIndexSupprise(licenseIndex) {
    if (licenseIndex > 4) {
      return topic(reviewTopicMap[4][1].indexes);
    } else {
      return topic(reviewTopicMap[licenseIndex][1].indexes);
    }
  }

  function checkLicenseIndexArray(licenseIndex) {
    if (licenseIndex > 4) {
      return reviewTopicMap[4][0].indexes;
    } else {
      return reviewTopicMap[licenseIndex][0].indexes;
    }
  }

  const item = licenseDetails.find((item) => item.name === licenseName);

  const totalDone = licenseResultOfUser[licenseIndex].reduce((partialSum, e) => partialSum + (e === null ? 1 : 0), 0);

  return (
    <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
      <RootStyle>
        <BannerSection />
        <Exam200Header />
        <Container component={MotionViewport} sx={{ mb: 5 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <m.div variants={varFade().inLeft}>
                <Link href={`/thi-gplx/xe-may/hang-bang-${licenseName.toLowerCase()}/thi-thu-de-ngau-nhien`} style={{ textDecoration: 'none' }} passHref>
                  <Item>
                    <Header sx={{ backgroundColor: '#3e67c3' }}>{data[licenseIndex]}</Header>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Image alt={"Thi thử ngẫu nhiên"} src={"/icons/motorcycle.png"} sx={{ height: 50, width: 50, mb: 1 }} />
                    </Box>
                    <Typography variant='h6'>Thi thử ngẫu nhiên</Typography>
                  </Item>
                </Link>
              </m.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <m.div variants={varFade().inDown}>
                <Link href={`/thi-gplx/xe-may/hang-bang-${licenseName.toLowerCase()}/thi-thu-de-tao-san`} style={{ textDecoration: 'none' }} passHref>
                  <Item>
                    <Header sx={{ backgroundColor: '#069cd5' }}> {totalExams - totalDone}/{item.totalExams} </Header>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Image alt={"Thi thử đề tạo sẵn"} src={"/icons/answer-2.png"} sx={{ height: 50, width: 50, mb: 1 }} />
                    </Box>
                    <Typography variant='h6'>Thi thử đề tạo sẵn</Typography>
                  </Item>
                </Link>
              </m.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <m.div variants={varFade().inRight}>
                <Link href={`/thi-gplx/xe-may/hang-bang-${licenseName.toLowerCase()}/on-tap`} style={{ textDecoration: 'none' }} passHref>
                  <Item>
                    <Header sx={{ backgroundColor: '#1ab776' }}>{array.length}</Header>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Image alt={"Ôn tập toàn bộ câu hỏi"} src={"/icons/quiz-2.png"} sx={{ height: 50, width: 50, mb: 1 }} />
                    </Box>
                    <Typography variant='h6'>Ôn tập toàn bộ câu hỏi</Typography>
                  </Item>
                </Link>
              </m.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <m.div variants={varFade().inLeft}>
                <Link href={`/thi-gplx/xe-may/hang-bang-${licenseName.toLowerCase()}/cau-diem-liet`} style={{ textDecoration: 'none' }} passHref>
                  <Item>
                    <Header sx={{ backgroundColor: '#f18312' }}>{surprise.length}</Header>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Image alt={"Ôn tập câu điểm liệt"} src={"/icons/wrong2.png"} sx={{ height: 50, width: 50, mb: 1 }} />
                    </Box>
                    <Typography variant='h6'>Ôn tập câu điểm liệt</Typography>
                  </Item>
                </Link>
              </m.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <m.div variants={varFade().inDown}>
                <Link href={`/thi-gplx/xe-may/hang-bang-${licenseName.toLowerCase()}/top-cau-sai`} passHref>
                  <Item>
                    <Header sx={{ backgroundColor: '#d13c3c' }}>{wrongQuestions}_50</Header>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Image alt={"Câu hỏi bị sai nhiều"} src={"/icons/choice.png"} sx={{ height: 50, width: 50, mb: 1 }} />
                    </Box>
                    <Typography variant='h6'>Câu hỏi làm sai</Typography>
                  </Item>
                </Link>
              </m.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <m.div variants={varFade().inRight}>
                <Link href={`/thi-gplx/bien-bao`} style={{ textDecoration: 'none' }} passHref>
                  <Item>
                    <Header sx={{ backgroundColor: '#e7bd00' }}>6</Header>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Image alt={"Biển báo giao thông"} src={"/icons/traffic-light2.png"} sx={{ height: 50, width: 50, mb: 1 }} />
                    </Box>
                    <Typography variant='h6'>Biển báo giao thông</Typography>
                  </Item>
                </Link>
              </m.div>
            </Grid>
          </Grid>
          <Divider sx={{ my: 5, height: 0 }} />
        </Container>
        <Practice licenseTypes={licenseTypes} />
      </RootStyle>
    </Container>
  );
}

function BannerSection() {
  return (
    <Grid container spacing={3} mb={6}>
      <Grid item xs={12} md={8}>
        <MotorSlider />
      </Grid>
      <Grid item xs={12} md={4}>
        <CardAds />
      </Grid>
    </Grid>);
}

function Practice({ licenseTypes }) {
  return (
    <Container component={MotionViewport} sx={{ mb: 5 }}>
      <m.div variants={varFade().inDown}>
        <Typography variant={'h2'} textAlign={"center"} textTransform={"capitalize"}>
          Bài thi sa hình xe máy đạt 100 điểm
        </Typography>
      </m.div>
      <Grid container spacing={2} mt={3}>
        {licenseTypes.filter(i => i.orderNo <= 2).map(item => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <LicenseTypeItem item={item} />
          </Grid>
        ))}
        <Grid item xs={12} sm={6} md={4}>
          <CardAds />
        </Grid>
      </Grid>
    </Container>
  );
}